import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

// Configure FirebaseUI.
export const uiConfig = (register, sign_in_options) => {
    /* Generates firebase config for Sign-In / Sign-Up UI
    inputs:
    - register: boolean for new registration. setting this to true will change the button 
        display text slightly
    - sign_in_options: Remote Config flags to toggle sign-in options on or off

    output:
    - (object) : UI config object used to configure StyledFirebaseAuth
    */

    const {
        microsoft_sign_in_active,
        email_sign_in_active,
        google_sign_in_active,
        facebook_sign_in_active,
    } = sign_in_options;
    let providers = [];

    if (register) {
        if (email_sign_in_active) {
            providers.push({
                provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                fullLabel: 'Sign up with email',
            });
        }
        if (google_sign_in_active) {
            providers.push({
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                fullLabel: 'Sign up with Google',
            });
        }
        if (facebook_sign_in_active) {
            providers.push({
                provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                fullLabel: 'Sign up with Facebook',
            });
        }
        if (microsoft_sign_in_active) {
            providers.push({
                provider: 'microsoft.com',
                providerName: 'Microsoft',
                //To override the full label of the button.
                // fullLabel: 'Login with Microsoft',
                buttonColor: '#2F2F2F',
                // iconUrl: '<icon-url-of-sign-in-button>',
                loginHintKey: 'login_hint',
                // scopes: [
                // 'mail.read'
                // ],
                // customParameters: {
                //     prompt: 'consent',
                // },
            });
        }
    } else {
        if (email_sign_in_active) {
            providers.push(firebase.auth.EmailAuthProvider.PROVIDER_ID);
        }
        if (google_sign_in_active) {
            providers.push({
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                fullLabel: 'Sign in with Google',
                customParameters: {
                    // Forces password re-entry.
                    // auth_type: 'reauthenticate',

                    // Forces google account selector
                    prompt: 'select_account',
                },
            });
        }
        if (facebook_sign_in_active) {
            providers.push({
                provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                fullLabel: 'Sign in with Facebook',
                scopes: ['email'],
            });
        }
        if (microsoft_sign_in_active) {
            providers.push({
                provider: 'microsoft.com',
                providerName: 'Microsoft',
                // To override the full label of the button.
                // fullLabel: 'Login with Microsoft',
                buttonColor: '#2F2F2F',
                // iconUrl: '<icon-url-of-sign-in-button>',
                loginHintKey: 'login_hint',
                customParameters: {
                    // Forces password re-entry.
                    // auth_type: 'reauthenticate',

                    // Forces google account selector
                    prompt: 'select_account',
                },
            });
        }
    }

    return {
        callbacks: {
            signInSuccessWithAuthResult: () => false,
        },
        // Popup signin flow rather than redirect flow.
        signInFlow: 'popup',
        // signInFlow: 'redirect',
        // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
        // signInSuccessUrl: '/signup',
        // We will display Emain, Google and Facebook as auth providers.
        signInOptions: providers,
        // tosUrl and privacyPolicyUrl accept either url string or a callback
        // function.
        // Terms of service url/callback.
        tosUrl: '/terms-of-use',
        // Required to enable one-tap sign-up credential helper.
        // Would need to implement uiCallback to get firebaseui object
        // credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,

        // Privacy policy url/callback.
        privacyPolicyUrl: function () {
            window.location.assign('/privacy');
        },
    };
};
